import { useNavigate } from "react-router";
import { CityWaitlistForm } from "../CityWaitlistForm/CityWaitlistForm";
import BranchCard from "./Components/BranchCard";
import { OurBranchesContainer,CalendarWrapper, CalendarPopup, Overlay } from "./OurBranches.styles";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const OurBranches = ({ cityJson }: any) => {

  const navigate = useNavigate();
  const calendarRef = useRef<HTMLDivElement>(null);

  const [selectedBranchLink, setSelectedBranchLink] = useState<string | null>(null);

  const handleBranchClick = (link: string) => {
    setSelectedBranchLink(link); // Show calendar for this branch
  };

  const handleDateSelect = (date: Date) => {
    if (selectedBranchLink) {
      const dateStr = `${date.getFullYear()}_${date.getMonth() + 1}_${date.getDate()}`;
    window.location.href = `${selectedBranchLink}/date-selection?date=${dateStr}`;
      setSelectedBranchLink(null); // Hide calendar after navigation
    }
  };

  const closePopup = () => {
    setSelectedBranchLink(null);
  };
  useEffect(() => {
    if (selectedBranchLink && calendarRef.current) {
      calendarRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [selectedBranchLink]);
  return (
    <OurBranchesContainer id="our-branches">
      <h2 className="heading">
      {`Our Branches in ${cityJson.name}`}
      </h2>
      {/* {(cityJson.name === "Chennai") && (
        <CityWaitlistForm />
      )} */}
      {(
        <div className="cards_container">
          {cityJson.branches.map((branch: any) => (
            <BranchCard
              link={branch.theatreLink}
              name={branch.name}
              image={branch.image}
              mapLink={branch.mapLink}
              address={branch.address}
              theatre={branch.theatres}
              onClick={() => handleBranchClick(branch.theatreLink)}
            />
          ))}
        </div>
      )}
      {selectedBranchLink && (
        <>
          <Overlay
    className={selectedBranchLink ? "show" : ""}
    onClick={() => setSelectedBranchLink(null)} // clicking outside closes calendar
  />
          <CalendarPopup>
      <CalendarWrapper
        className={selectedBranchLink ? "show" : ""}
        ref={calendarRef}
      >
        <Calendar
          onChange={(value) => {
            if (value instanceof Date) handleDateSelect(value);
            else if (Array.isArray(value) && value[0] instanceof Date)
              handleDateSelect(value[0]);
          }}
          minDate={new Date()}
        />
      </CalendarWrapper>
      </CalendarPopup>
      </>
      )}
    </OurBranchesContainer>
  );
};

export default OurBranches;
